import { PartiallyConstructible, Point } from '../utils';
import { ParametricFilter, } from './ParametricFilters';
/**
The result of the health insurance card recognition
*/
export class PageData extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<PageData>`} */
    constructor(source = {}) {
        super();
        /**
          The list of filters applied to the page
          */
        this.filters = null;
        /**
          The polygon of the page
          */
        this.polygon = [];
        /**
          The detection status of the page
          */
        this.documentDetectionStatus = null;
        /**
          The quality score of the page
          */
        this.documentQuality = null;
        /**
          The source of the page image
          */
        this.source = null;
        /**
          The URI of the document image
          */
        this.documentImageURI = null;
        /**
          The URI of the unfiltered document image
          */
        this.unfilteredDocumentImageURI = null;
        /**
          The URI of the document image preview
          */
        this.documentImagePreviewURI = null;
        if (source.uuid !== undefined) {
            this.uuid = source.uuid;
        }
        else {
            throw new Error('uuid must be present in constructor argument');
        }
        if (source.filters !== undefined) {
            this.filters =
                source.filters != null
                    ? source.filters.map(it => ParametricFilter.From(it))
                    : null;
        }
        if (source.polygon !== undefined) {
            this.polygon = source.polygon.map(it => new Point(it.x, it.y));
        }
        if (source.documentDetectionStatus !== undefined) {
            this.documentDetectionStatus =
                source.documentDetectionStatus != null
                    ? source.documentDetectionStatus
                    : null;
        }
        if (source.documentQuality !== undefined) {
            this.documentQuality =
                source.documentQuality != null ? source.documentQuality : null;
        }
        if (source.source !== undefined) {
            this.source = source.source != null ? source.source : null;
        }
        if (source.originalImageURI !== undefined) {
            this.originalImageURI = source.originalImageURI;
        }
        else {
            throw new Error('originalImageURI must be present in constructor argument');
        }
        if (source.documentImageURI !== undefined) {
            this.documentImageURI =
                source.documentImageURI != null ? source.documentImageURI : null;
        }
        if (source.unfilteredDocumentImageURI !== undefined) {
            this.unfilteredDocumentImageURI =
                source.unfilteredDocumentImageURI != null
                    ? source.unfilteredDocumentImageURI
                    : null;
        }
        if (source.documentImagePreviewURI !== undefined) {
            this.documentImagePreviewURI =
                source.documentImagePreviewURI != null
                    ? source.documentImagePreviewURI
                    : null;
        }
    }
}
//# sourceMappingURL=PageData.js.map